import { SignUpState } from "./types";

export function getDefaultState(): SignUpState {
	return {
	    isComplete: false,
        isCreditCardRequired: false,
		companyInfo: {
		    name: "",
            address: "",
            latLong: "",
            timeZoneId: 35
        },
        securityInfo: {
	        password: "",
            passwordConfirmation: ""
        },
        contactInfo: {
		    firstName: "",
            lastName: "",
            telephone: "",
            email: "",
            addressLine1: "",
            addressLine2: "",
            city: "",
            country: "",
            state: "",
            zipCode: "",
            currency: ""
        },
        customerId: 0,
        steps: [
            {
                number: 1,
                title: "Contact Information",
                description: "Submit your contact information to get started.",
                route: "/contactinfo"
            },
            {
                number: 2,
                title: "Security Information",
                description: "Secure your account.",
                route: "/securityinfo"
            },
            {
                number: 3,
                title: "Company Information",
                description: "Set your organization details.",
                notes: "These details will be used to configure your account.",
                route: "/companyinfo"
            },
            {
                number: 4,
                title: "Payment Information",
                description: "Set up your payment.",
                notes: "Your credit card will not be charged until your 30-day free trial has concluded.",
                route: "/paymentinfo"
            }
        ],
        timeZones: [
            {
                timeZoneID: 1,
                id: "Dateline Standard Time",
				displayName: "(UTC-12:00) Dateline Standard Time"
            },
            {
                timeZoneID: 2,
                id: "UTC-11",
				displayName: "(UTC-11:00) Coordinated Universal Time"
            },
            {
                timeZoneID: 3,
                id: "Samoa Standard Time",
				displayName: "(UTC-11:00) Samoa Standard Time"
            },
            {
                timeZoneID: 4,
                id: "Hawaiian Standard Time",
				displayName: "(UTC-10:00) Hawaiian Standard Time"
            },
            {
                timeZoneID: 5,
                id: "Alaskan Standard Time",
				displayName: "(UTC-09:00) Alaskan Standard Time"
            },
            {
                timeZoneID: 6,
                id: "Pacific Standard Time (Mexico)",
				displayName: "(UTC-08:00) Pacific Standard Time (Mexico)"
            },
            {
                timeZoneID: 7,
                id: "Pacific Standard Time",
				displayName: "(UTC-08:00) Pacific Standard Time"
            },
            {
                timeZoneID: 8,
                id: "US Mountain Standard Time",
				displayName: "(UTC-07:00) US Mountain Standard Time"
            },
            {
                timeZoneID: 9,
                id: "Mountain Standard Time (Mexico)",
				displayName: "(UTC-07:00) Mountain Standard Time (Mexico)"
            },
            {
                timeZoneID: 10,
                id: "Mountain Standard Time",
				displayName: "(UTC-07:00) Mountain Standard Time"
            },
            {
                timeZoneID: 11,
                id: "Central America Standard Time",
				displayName: "(UTC-06:00) Central America Standard Time"
            },
            {
                timeZoneID: 12,
                id: "Central Standard Time",
				displayName: "(UTC-06:00) Central Standard Time"
            },
            {
                timeZoneID: 13,
                id: "Central Standard Time (Mexico)",
				displayName: "(UTC-06:00) Central Standard Time (Mexico)"
            },
            {
                timeZoneID: 14,
                id: "Canada Central Standard Time",
				displayName: "(UTC-06:00) Canada Central Standard Time"
            },
            {
                timeZoneID: 15,
                id: "SA Pacific Standard Time",
				displayName: "(UTC-05:00) SA Pacific Standard Time"
            },
            {
                timeZoneID: 16,
                id: "Eastern Standard Time",
				displayName: "(UTC-05:00) Eastern Standard Time"
            },
            {
                timeZoneID: 17,
                id: "US Eastern Standard Time",
				displayName: "(UTC-05:00) US Eastern Standard Time"
            },
            {
                timeZoneID: 18,
                id: "Venezuela Standard Time",
				displayName: "(UTC-04:30) Venezuela Standard Time"
            },
            {
                timeZoneID: 19,
                id: "Paraguay Standard Time",
				displayName: "(UTC-04:00) Paraguay Standard Time"
            },
            {
                timeZoneID: 20,
                id: "Atlantic Standard Time",
				displayName: "(UTC-04:00) Atlantic Standard Time"
            },
            {
                timeZoneID: 21,
                id: "Central Brazilian Standard Time",
				displayName: "(UTC-04:00) Central Brazilian Standard Time"
            },
            {
                timeZoneID: 22,
                id: "SA Western Standard Time",
				displayName: "(UTC-04:00) SA Western Standard Time"
            },
            {
                timeZoneID: 23,
                id: "Pacific SA Standard Time",
				displayName: "(UTC-04:00) Pacific SA Standard Time"
            },
            {
                timeZoneID: 24,
                id: "Newfoundland Standard Time",
				displayName: "(UTC-03:30) Pacific SA Standard Time"
            },
            {
                timeZoneID: 25,
                id: "E. South America Standard Time",
				displayName: "(UTC-03:00) E. South America Standard Time"
            },
            {
                timeZoneID: 26,
                id: "Argentina Standard Time",
				displayName: "(UTC-03:00) Argentina Standard Time"
            },
            {
                timeZoneID: 27,
                id: "SA Eastern Standard Time",
				displayName: "(UTC-03:00) SA Eastern Standard Time"
            },
            {
                timeZoneID: 28,
                id: "Greenland Standard Time",
				displayName: "(UTC-03:00) Greenland Standard Time"
            },
            {
                timeZoneID: 29,
                id: "Montevideo Standard Time",
				displayName: "(UTC-03:00) Montevideo Standard Time"
            },
            {
                timeZoneID: 31,
                id: "Mid-Atlantic Standard Time",
				displayName: "(UTC-02:00) Atlantic Standard Time"
            },
            {
                timeZoneID: 32,
                id: "Azores Standard Time",
				displayName: "(UTC-01:00) Azores Standard Time"
            },
            {
                timeZoneID: 33,
                id: "Cape Verde Standard Time",
				displayName: "(UTC-01:00) Cape Verde Standard Time"
            },
            {
                timeZoneID: 34,
                id: "Morocco Standard Time",
				displayName: "(UTC) Morocco Standard Time"
            },
            {
                timeZoneID: 36,
                id: "GMT Standard Time",
				displayName: "(UTC) GMT Standard Time"
            },
            {
                timeZoneID: 37,
                id: "Greenwich Standard Time",
				displayName: "(UTC) Greenwich Standard Time"
            },
            {
                timeZoneID: 38,
                id: "W. Europe Standard Time",
				displayName: "(UTC+01:00) W. Europe Standard Time"
            },
            {
                timeZoneID: 39,
                id: "Central Europe Standard Time",
				displayName: "(UTC+01:00) Central Europe Standard Time"
            },
            {
                timeZoneID: 40,
                id: "Romance Standard Time",
				displayName: "(UTC+01:00) Romance Standard Time"
            },
            {
                timeZoneID: 41,
                id: "Central European Standard Time",
				displayName: "(UTC+01:00) Central European Standard Time"
            },
            {
                timeZoneID: 42,
                id: "W. Central Africa Standard Time",
				displayName: "(UTC+01:00) W. Central Africa Standard Time"
            },
            {
                timeZoneID: 43,
                id: "Namibia Standard Time",
				displayName: "(UTC+01:00) Namibia Standard Time"
            },
            {
                timeZoneID: 44,
                id: "Jordan Standard Time",
				displayName: "(UTC+02:00) Jordan Standard Time"
            },
            {
                timeZoneID: 45,
                id: "GTB Standard Time",
				displayName: "(UTC+02:00) GTB Standard Time"
            },
            {
                timeZoneID: 46,
                id: "Middle East Standard Time",
				displayName: "(UTC+02:00) Middle East Standard Time"
            },
            {
                timeZoneID: 47,
                id: "Egypt Standard Time",
				displayName: "(UTC+02:00) Egypt Standard Time"
            },
            {
                timeZoneID: 48,
                id: "Syria Standard Time",
				displayName: "(UTC+02:00) Syria Standard Time"
            },
            {
                timeZoneID: 49,
                id: "South Africa Standard Time",
				displayName: "(UTC+02:00) South Africa Standard Time"
            },
            {
                timeZoneID: 50,
                id: "FLE Standard Time",
				displayName: "(UTC+02:00) FLE Standard Time"
            },
            {
                timeZoneID: 51,
                id: "Israel Standard Time",
				displayName: "(UTC+02:00) Israel Standard Time"
            },
            {
                timeZoneID: 52,
                id: "E. Europe Standard Time",
				displayName: "(UTC+02:00) E. Europe Standard Time"
            },
            {
                timeZoneID: 53,
                id: "Arabic Standard Time",
				displayName: "(UTC+03:00) Arabic Standard Time"
            },
            {
                timeZoneID: 54,
                id: "Arab Standard Time",
				displayName: "(UTC+03:00) Arab Standard Time"
            },
            {
                timeZoneID: 55,
                id: "Russian Standard Time",
				displayName: "(UTC+03:00) Russian Standard Time"
            },
            {
                timeZoneID: 56,
                id: "E. Africa Standard Time",
				displayName: "(UTC+03:00) E. Africa Standard Time"
            },
            {
                timeZoneID: 57,
                id: "Iran Standard Time",
				displayName: "(UTC+03:30) Iran Standard Time"
            },
            {
                timeZoneID: 58,
                id: "Arabian Standard Time",
				displayName: "(UTC+04:00) Arabian Standard Time"
            },
            {
                timeZoneID: 59,
                id: "Azerbaijan Standard Time",
				displayName: "(UTC+04:00) Azerbaijan Standard Time"
            },
            {
                timeZoneID: 60,
                id: "Mauritius Standard Time",
				displayName: "(UTC+04:00) Mauritius Standard Time"
            },
            {
                timeZoneID: 61,
                id: "Georgian Standard Time",
				displayName: "(UTC+04:00) Georgian Standard Time"
            },
            {
                timeZoneID: 62,
                id: "Caucasus Standard Time",
				displayName: "(UTC+04:00) Caucasus Standard Time"
            },
            {
                timeZoneID: 63,
                id: "Afghanistan Standard Time",
				displayName: "(UTC+04:30) Afghanistan Standard Time"
            },
            {
                timeZoneID: 64,
                id: "Ekaterinburg Standard Time",
				displayName: "(UTC+05:00) Ekaterinburg Standard Time"
            },
            {
                timeZoneID: 65,
                id: "Pakistan Standard Time",
				displayName: "(UTC+05:00) Pakistan Standard Time"
            },
            {
                timeZoneID: 66,
                id: "West Asia Standard Time",
				displayName: "(UTC+05:00) West Asia Standard Time"
            },
            {
                timeZoneID: 67,
                id: "India Standard Time",
				displayName: "(UTC+05:30) India Standard Time"
            },
            {
                timeZoneID: 68,
                id: "Sri Lanka Standard Time",
				displayName: "(UTC+05:30) Sri Lanka Standard Time"
            },
            {
                timeZoneID: 69,
                id: "Nepal Standard Time",
				displayName: "(UTC+05:45) Nepal Standard Time"
            },
            {
                timeZoneID: 70,
                id: "Central Asia Standard Time",
				displayName: "(UTC+06:00) Central Asia Standard Time"
            },
            {
                timeZoneID: 71,
                id: "Bangladesh Standard Time",
				displayName: "(UTC+06:00) Bangladesh Standard Time"
            },
            {
                timeZoneID: 72,
                id: "N. Central Asia Standard Time",
				displayName: "(UTC+06:00) N. Central Asia Standard Time"
            },
            {
                timeZoneID: 73,
                id: "Myanmar Standard Time",
				displayName: "(UTC+06:30) Myanmar Standard Time"
            },
            {
                timeZoneID: 74,
                id: "SE Asia Standard Time",
				displayName: "(UTC+07:00) SE Asia Standard Time"
            },
            {
                timeZoneID: 75,
                id: "North Asia Standard Time",
				displayName: "(UTC+07:00) North Asia Standard Time"
            },
            {
                timeZoneID: 76,
                id: "China Standard Time",
				displayName: "(UTC+08:00) China Standard Time"
            },
            {
                timeZoneID: 77,
                id: "North Asia East Standard Time",
				displayName: "(UTC+08:00) North Asia East Standard Time"
            },
            {
                timeZoneID: 78,
                id: "Singapore Standard Time",
				displayName: "(UTC+08:00) Singapore Standard Time"
            },
            {
                timeZoneID: 79,
                id: "W. Australia Standard Time",
				displayName: "(UTC+08:00) W. Australia Standard Time"
            },
            {
                timeZoneID: 80,
                id: "Taipei Standard Time",
				displayName: "(UTC+08:00) Taipei Standard Time"
            },
            {
                timeZoneID: 81,
                id: "Ulaanbaatar Standard Time",
				displayName: "(UTC+08:00) Ulaanbaatar Standard Time"
            },
            {
                timeZoneID: 82,
                id: "Tokyo Standard Time",
				displayName: "(UTC+09:00) Tokyo Standard Time"
            },
            {
                timeZoneID: 83,
                id: "Korea Standard Time",
				displayName: "(UTC+09:00) Korea Standard Time"
            },
            {
                timeZoneID: 84,
                id: "Yakutsk Standard Time",
				displayName: "(UTC+09:00) Yakutsk Standard Time"
            },
            {
                timeZoneID: 85,
                id: "Cen. Australia Standard Time",
				displayName: "(UTC+09:30) Cen. Australia Standard Time"
            },
            {
                timeZoneID: 86,
                id: "AUS Central Standard Time",
				displayName: "(UTC+09:30) AUS Central Standard Time"
            },
            {
                timeZoneID: 87,
                id: "E. Australia Standard Time",
				displayName: "(UTC+10:00) E. Australia Standard Time"
            },
            {
                timeZoneID: 88,
                id: "AUS Eastern Standard Time",
				displayName: "(UTC+10:00) AUS Eastern Standard Time"
            },
            {
                timeZoneID: 89,
                id: "West Pacific Standard Time",
				displayName: "(UTC+10:00) West Pacific Standard Time"
            },
            {
                timeZoneID: 90,
                id: "Tasmania Standard Time",
				displayName: "(UTC+10:00) Tasmania Standard Time"
            },
            {
                timeZoneID: 91,
                id: "Vladivostok Standard Time",
				displayName: "(UTC+10:00) Vladivostok Standard Time"
            },
            {
                timeZoneID: 92,
                id: "Magadan Standard Time",
				displayName: "(UTC+11:00) Magadan Standard Time"
            },
            {
                timeZoneID: 93,
                id: "Central Pacific Standard Time",
				displayName: "(UTC+11:00) Central Pacific Standard Time"
            },
            {
                timeZoneID: 94,
                id: "New Zealand Standard Time",
				displayName: "(UTC+12:00) New Zealand Standard Time"
            },
            {
                timeZoneID: 95,
                id: "UTC+12:00",
				displayName: "(UTC+12:00) Fiji Standard Time"
            },
            {
                timeZoneID: 96,
                id: "Fiji Standard Time",
				displayName: "(UTC+12:00) Fiji Standard Time"
            },
            {
                timeZoneID: 97,
                id: "Kamchatka Standard Time",
				displayName: "(UTC+13:00) Kamchatka Standard Time"
            },
            {
                timeZoneID: 98,
                id: "Tonga Standard Time",
				displayName: "(UTC+13:00) Tonga Standard Time"
            }
        ],
		// tslint:disable-next-line
        countryOptions: [["United States","US"],["United Kingdom","GB"],["Canada","CA"],["New Zealand","NZ"],["Australia","AU"],["South Africa","ZA"],["Singapore","SG"],["--","--"],["Afghanistan","AF"],["Albania","AL"],["Algeria","DZ"],["American Samoa","AS"],["Andorra","AD"],["Angola","AO"],["Anguilla","AI"],["Antarctica","AQ"],["Antigua and Barbuda","AG"],["Argentina","AR"],["Armenia","AM"],["Aruba","AW"],["Australia","AU"],["Austria","AT"],["Azerbaijan","AZ"],["Bahamas","BS"],["Bahrain","BH"],["Bangladesh","BD"],["Barbados","BB"],["Belarus","BY"],["Belgium","BE"],["Belize","BZ"],["Benin","BJ"],["Bermuda","BM"],["Bhutan","BT"],["Bolivia","BO"],["Bonaire, Sint Eustatius and Saba","BQ"],["Bosnia and Herzegovina","BA"],["Botswana","BW"],["Bouvet Island","BV"],["Brazil","BR"],["British Indian Ocean Territory","IO"],["Brunei Darussalam","BN"],["Bulgaria","BG"],["Burkina Faso","BF"],["Burundi","BI"],["Cambodia","KH"],["Cameroon","CM"],["Canada","CA"],["Canary Islands","IC"],["Cape Verde","CV"],["Cayman Islands","KY"],["Central African Republic","CF"],["Chad","TD"],["Chile","CL"],["China","CN"],["Christmas Island","CX"],["Cocos (Keeling) Islands","CC"],["Colombia","CO"],["Comoros","KM"],["Congo","CG"],["Congo, The Democratic Republic Of The","CD"],["Cook Islands","CK"],["Costa Rica","CR"],["Croatia","HR"],["Cuba","CU"],["Curaçao","CW"],["Cyprus","CY"],["Czech Republic","CZ"],["Côte D'Ivoire","CI"],["Denmark","DK"],["Djibouti","DJ"],["Dominica","DM"],["Dominican Republic","DO"],["Ecuador","EC"],["Egypt","EG"],["El Salvador","SV"],["Equatorial Guinea","GQ"],["Eritrea","ER"],["Estonia","EE"],["Ethiopia","ET"],["Falkland Islands (Malvinas)","FK"],["Faroe Islands","FO"],["Fiji","FJ"],["Finland","FI"],["France","FR"],["French Guiana","GF"],["French Polynesia","PF"],["French Southern Territories","TF"],["Gabon","GA"],["Gambia","GM"],["Georgia","GE"],["Germany","DE"],["Ghana","GH"],["Gibraltar","GI"],["Greece","GR"],["Greenland","GL"],["Grenada","GD"],["Guadeloupe","GP"],["Guam","GU"],["Guatemala","GT"],["Guernsey","GG"],["Guinea","GN"],["Guinea-Bissau","GW"],["Guyana","GY"],["Haiti","HT"],["Heard and McDonald Islands","HM"],["Holy See (Vatican City State)","VA"],["Honduras","HN"],["Hong Kong","HK"],["Hungary","HU"],["Iceland","IS"],["India","IN"],["Indonesia","ID"],["Iran, Islamic Republic Of","IR"],["Iraq","IQ"],["Ireland","IE"],["Isle of Man","IM"],["Israel","IL"],["Italy","IT"],["Jamaica","JM"],["Japan","JP"],["Jersey","JE"],["Jordan","JO"],["Kazakhstan","KZ"],["Kenya","KE"],["Kiribati","KI"],["Korea, Democratic People's Republic Of","KP"],["Korea, Republic of","KR"],["Kuwait","KW"],["Kyrgyzstan","KG"],["Lao People's Democratic Republic","LA"],["Latvia","LV"],["Lebanon","LB"],["Lesotho","LS"],["Liberia","LR"],["Libya","LY"],["Liechtenstein","LI"],["Lithuania","LT"],["Luxembourg","LU"],["Macao","MO"],["Macedonia, the Former Yugoslav Republic Of","MK"],["Madagascar","MG"],["Malawi","MW"],["Malaysia","MY"],["Maldives","MV"],["Mali","ML"],["Malta","MT"],["Marshall Islands","MH"],["Martinique","MQ"],["Mauritania","MR"],["Mauritius","MU"],["Mayotte","YT"],["Mexico","MX"],["Micronesia, Federated States Of","FM"],["Moldova, Republic of","MD"],["Monaco","MC"],["Mongolia","MN"],["Montenegro","ME"],["Montserrat","MS"],["Morocco","MA"],["Mozambique","MZ"],["Myanmar","MM"],["Namibia","NA"],["Nauru","NR"],["Nepal","NP"],["Netherlands","NL"],["Netherlands Antilles","AN"],["New Caledonia","NC"],["New Zealand","NZ"],["Nicaragua","NI"],["Niger","NE"],["Nigeria","NG"],["Niue","NU"],["Norfolk Island","NF"],["Northern Mariana Islands","MP"],["Norway","NO"],["Oman","OM"],["Pakistan","PK"],["Palau","PW"],["Palestine, State of","PS"],["Panama","PA"],["Papua New Guinea","PG"],["Paraguay","PY"],["Peru","PE"],["Philippines","PH"],["Pitcairn","PN"],["Poland","PL"],["Portugal","PT"],["Puerto Rico","PR"],["Qatar","QA"],["Romania","RO"],["Russian Federation","RU"],["Rwanda","RW"],["Réunion","RE"],["Saint Barthélemy","BL"],["Saint Helena","SH"],["Saint Kitts And Nevis","KN"],["Saint Lucia","LC"],["Saint Martin","MF"],["Saint Pierre And Miquelon","PM"],["Saint Vincent And The Grenedines","VC"],["Samoa","WS"],["San Marino","SM"],["Sao Tome and Principe","ST"],["Saudi Arabia","SA"],["Senegal","SN"],["Serbia","RS"],["Seychelles","SC"],["Sierra Leone","SL"],["Singapore","SG"],["Sint Maarten","SX"],["Slovakia","SK"],["Slovenia","SI"],["Solomon Islands","SB"],["Somalia","SO"],["South Africa","ZA"],["South Georgia and the South Sandwich Islands","GS"],["South Sudan","SS"],["Spain","ES"],["Sri Lanka","LK"],["Sudan","SD"],["Suriname","SR"],["Svalbard And Jan Mayen","SJ"],["Swaziland","SZ"],["Sweden","SE"],["Switzerland","CH"],["Syrian Arab Republic","SY"],["Taiwan, Republic Of China","TW"],["Tajikistan","TJ"],["Tanzania, United Republic of","TZ"],["Thailand","TH"],["Timor-Leste","TL"],["Togo","TG"],["Tokelau","TK"],["Tonga","TO"],["Trinidad and Tobago","TT"],["Tunisia","TN"],["Turkey","TR"],["Turkmenistan","TM"],["Turks and Caicos Islands","TC"],["Tuvalu","TV"],["Uganda","UG"],["Ukraine","UA"],["United Arab Emirates","AE"],["United Kingdom","GB"],["United States","US"],["United States Minor Outlying Islands","UM"],["Uruguay","UY"],["Uzbekistan","UZ"],["Vanuatu","VU"],["Venezuela, Bolivarian Republic of","VE"],["Vietnam","VN"],["Virgin Islands, British","VG"],["Virgin Islands, U.S.","VI"],["Wallis and Futuna","WF"],["Western Sahara","EH"],["Yemen","YE"],["Zambia","ZM"],["Zimbabwe","ZW"],["Åland Islands","AX"]]
	}
}
